(() => {
  const loader = document.currentScript;

  function ensureStyles() {
    if (document.getElementById('kion-lp-buy-bar-styles')) return;

    const styles = document.createElement('style');
    styles.id = 'kion-lp-buy-bar-styles';
    styles.textContent = `
      .kion-lp-entry-position { position: relative; }
      .kion-lp-entry-link { position: absolute; inset: 0; z-index: 3; display: block; cursor: pointer; }
      .kion-lp-entry-link:focus-visible { outline: 3px solid #111; outline-offset: -3px; }
      .kion-lp-buy-bar[hidden], .kion-lp-buy-bar [hidden] { display: none !important; }
      .kion-lp-buy-bar {
        position: fixed;
        inset: auto 0 0;
        z-index: 99999;
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        box-sizing: border-box;
        padding: 10px 24px calc(10px + env(safe-area-inset-bottom, 0px));
        background: #fff;
        color: #000;
        box-shadow: 0 -5px 20px rgb(0 0 0 / 12%);
        font-family: "Spock W05 Regular", sans-serif;
      }
      .kion-lp-buy-bar__product { display: flex; align-items: center; gap: 12px; min-width: 0; }
      .kion-lp-buy-bar__image { width: 64px; height: 64px; object-fit: contain; flex-shrink: 0; }
      .kion-lp-buy-bar__copy { min-width: 0; line-height: 1.25; }
      .kion-lp-buy-bar__title { font-size: 16px; font-weight: 600; }
      .kion-lp-buy-bar__price { display: flex; align-items: baseline; flex-wrap: wrap; gap: 8px; font-size: 15px; margin-top: 4px; }
      .kion-lp-buy-bar__compare-price { color: #666; font-weight: 400; }
      .kion-lp-buy-bar__current-price { font-weight: 600; }
      .kion-lp-buy-bar__button {
        flex-shrink: 0;
        min-width: 150px;
        min-height: 56px;
        padding: 12px 24px;
        border: 0;
        border-radius: 0;
        background: #f7ab35;
        color: #000;
        font: 600 16px "Spock W05 Regular", sans-serif;
        cursor: pointer;
      }
      .kion-lp-buy-bar__button:hover { background: #f2a127; }
      .kion-lp-buy-bar__button:focus-visible { outline: 2px solid #000; outline-offset: 3px; }
      body.kion-lp-buy-bar-visible { padding-bottom: var(--kion-lp-buy-bar-height, 84px); }
      body.kion-lp-buy-bar-visible #gorgias-chat-container iframe#chat-button,
      body.kion-lp-buy-bar-visible #rebuy-bubble-global-alert-modal { bottom: calc(var(--kion-lp-buy-bar-height, 84px) + 16px) !important; }
      @media (max-width: 600px) {
        .kion-lp-buy-bar { padding: 8px 12px calc(8px + env(safe-area-inset-bottom, 0px)); gap: 10px; }
        .kion-lp-buy-bar__product { gap: 8px; }
        .kion-lp-buy-bar__image { width: 48px; height: 48px; }
        .kion-lp-buy-bar__title { font-size: 14px; }
        .kion-lp-buy-bar__price { font-size: 13px; }
        .kion-lp-buy-bar__button { min-width: 116px; min-height: 48px; padding: 10px 16px; font-size: 14px; }
      }
    `;
    document.head.appendChild(styles);
  }

  function ensureBar() {
    const existingBar = document.querySelector('[data-kion-lp-buy-bar]');
    if (existingBar) return existingBar;

    const bar = document.createElement('div');
    bar.className = 'kion-lp-buy-bar';
    bar.setAttribute('data-kion-lp-buy-bar', '');
    bar.dataset.logoLabel = loader?.dataset.logoLabel || 'Go to the product options';
    bar.dataset.heroLabel = loader?.dataset.heroLabel || 'Go to the product options';
    bar.hidden = true;

    const product = document.createElement('div');
    product.className = 'kion-lp-buy-bar__product';

    const image = document.createElement('img');
    image.className = 'kion-lp-buy-bar__image';
    image.setAttribute('data-lp-bar-image', '');
    image.alt = '';
    image.width = 64;
    image.height = 64;
    image.hidden = true;

    const copy = document.createElement('div');
    copy.className = 'kion-lp-buy-bar__copy';

    const title = document.createElement('div');
    title.className = 'kion-lp-buy-bar__title';
    title.setAttribute('data-lp-bar-title', '');

    const priceGroup = document.createElement('div');
    priceGroup.className = 'kion-lp-buy-bar__price';
    priceGroup.setAttribute('data-lp-bar-price-group', '');

    const comparePrice = document.createElement('s');
    comparePrice.className = 'kion-lp-buy-bar__compare-price';
    comparePrice.setAttribute('data-lp-bar-compare-price', '');
    comparePrice.hidden = true;

    const price = document.createElement('span');
    price.className = 'kion-lp-buy-bar__current-price';
    price.setAttribute('data-lp-bar-price', '');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'kion-lp-buy-bar__button';
    button.setAttribute('data-lp-bar-button', '');
    button.textContent = loader?.dataset.buyNowLabel || 'Buy now';

    priceGroup.append(comparePrice, price);
    copy.append(title, priceGroup);
    product.append(image, copy);
    bar.append(product, button);
    document.body.appendChild(bar);
    return bar;
  }

  function start() {
    ensureStyles();
    const bar = ensureBar();
    if (!bar || bar.dataset.initialized) return;

    bar.dataset.initialized = 'true';
    const title = bar.querySelector('[data-lp-bar-title]');
    const priceGroup = bar.querySelector('[data-lp-bar-price-group]');
    const comparePrice = bar.querySelector('[data-lp-bar-compare-price]');
    const price = bar.querySelector('[data-lp-bar-price]');
    const image = bar.querySelector('[data-lp-bar-image]');
    const button = bar.querySelector('[data-lp-bar-button]');
    let box;
    let queued = false;
    let contentDirty = true;
    let entryLinksDirty = true;

    function findBox() {
      const forms = [...document.querySelectorAll('form[action*="/cart/add"]')];
      const form = forms.find((element) => !element.closest('#rebuy-cart') && element.getBoundingClientRect().height > 0);
      if (!form) return null;
      return form.closest('.kion-buy-box, .home-buy-box, [data-kion-buy-box]') || form.closest('.shg-c') || form;
    }

    function syncContent() {
      const heading = box.querySelector('.product-title, [itemprop="name"], h1, h2');
      title.textContent = heading?.textContent.trim() || '';
      const sourcePrice = box.querySelector('#kion3JP1-product-display-price, [data-price-wrapper]');
      const sourceComparePrice = sourcePrice?.querySelector('s, del')?.textContent.trim() || '';
      const priceCopy = sourcePrice?.cloneNode(true);
      priceCopy?.querySelectorAll('s, del, .visually-hidden, .sr-only').forEach((element) => element.remove());
      price.textContent = priceCopy?.textContent.trim() || '';
      comparePrice.textContent = sourceComparePrice;
      comparePrice.hidden = !sourceComparePrice || sourceComparePrice === price.textContent;
      priceGroup.hidden = !price.textContent;
      const images = [...box.querySelectorAll('.kion3JP1-shogun-buy-box-image-image, .buy-box-image img, .product-buy-box img')];
      const sourceImage = images.find((element) => element.getBoundingClientRect().width > 0) || images[0];
      const src = sourceImage?.currentSrc || sourceImage?.getAttribute('src');
      if (src && image.getAttribute('src') !== src) image.src = src;
      image.hidden = !src;
    }

    function scrollToBuyBox() {
      if (!box?.isConnected) return;
      const target = box.querySelector('.buy-box-form') || box;
      const hadTabindex = target.hasAttribute('tabindex');
      if (!hadTabindex) {
        target.setAttribute('tabindex', '-1');
        target.addEventListener('blur', () => target.removeAttribute('tabindex'), { once: true });
      }
      target.focus({ preventScroll: true });
      const headerBottom = [...document.querySelectorAll('.sticky-header, .sticky-header1')].reduce((bottom, header) => {
        const rect = header.getBoundingClientRect();
        const fixed = ['fixed', 'sticky'].includes(getComputedStyle(header).position);
        return fixed && rect.top <= 0 && rect.bottom > 0 ? Math.max(bottom, rect.bottom) : bottom;
      }, 0);
      window.scrollTo({
        top: Math.max(0, window.scrollY + target.getBoundingClientRect().top - headerBottom - 16),
        behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
      });
    }

    function connectEntryLinks() {
      if (!box || !document.querySelector('a[name="buy-now"], #buy-now')) return;
      const targets = new Map();
      document.querySelectorAll('.kion-lp-logo').forEach((element) => targets.set(element, bar.dataset.logoLabel));
      const roots = [...document.querySelectorAll('.padding-top')].filter((element) =>
        element.compareDocumentPosition(box) & Node.DOCUMENT_POSITION_FOLLOWING
      );
      const heroIndex = roots.findIndex((element) => element.querySelector('h1'));
      const heroRoots = heroIndex < 0 ? [] : [roots[heroIndex]];
      const mobileHero = roots[heroIndex + 1];
      if (
        heroIndex >= 0 &&
        mobileHero &&
        !mobileHero.querySelector('h1, h2, p, button, input') &&
        mobileHero.querySelector('.shogun-image-container')
      ) {
        heroRoots.push(mobileHero);
      }
      heroRoots.forEach((root) => {
        root.querySelectorAll('.shogun-image-container, .shg-box').forEach((element) => {
          if (element.querySelector('h1, h2, h3, p, button, input, video, iframe')) return;
          if (
            element.matches('.shogun-image-container') ||
            (!element.textContent.trim() && getComputedStyle(element).backgroundImage !== 'none')
          ) {
            targets.set(element, bar.dataset.heroLabel);
          }
        });
      });
      targets.forEach((label, element) => {
        if (element.dataset.kionEntryLinked) return;
        let link = element.matches('a') ? element : element.querySelector('a');
        if (!link) {
          link = document.createElement('a');
          link.className = 'kion-lp-entry-link';
          if (getComputedStyle(element).position === 'static') element.classList.add('kion-lp-entry-position');
          element.appendChild(link);
        }
        link.setAttribute('href', '#buy-now');
        link.setAttribute('aria-label', label);
        link.setAttribute('data-kion-entry-link', label === bar.dataset.logoLabel ? 'logo' : 'hero');
        link.addEventListener('click', (event) => {
          if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button !== 0) return;
          event.preventDefault();
          scrollToBuyBox();
        });
        element.dataset.kionEntryLinked = 'true';
      });
    }

    const boxObserver = new MutationObserver(() => {
      contentDirty = true;
      schedule();
    });

    function findHeroSection() {
      const root = box?.closest('.shogun-root') || document.querySelector('.shogun-root');
      if (!root) return null;
      const sections = [...root.children].filter((element) => {
        const rect = element.getBoundingClientRect();
        return rect.width > 0 && rect.height >= 160 && getComputedStyle(element).position !== 'fixed';
      });
      return sections.find((element) => element.querySelector('h1')) || null;
    }

    function update() {
      queued = false;
      if (!box?.isConnected || !box.getBoundingClientRect().height) {
        boxObserver.disconnect();
        box = findBox();
        if (box) {
          boxObserver.observe(box, {
            childList: true,
            subtree: true,
            characterData: true,
            attributes: true,
            attributeFilter: ['src'],
          });
          contentDirty = true;
        }
      }
      if (box && contentDirty) {
        syncContent();
        contentDirty = false;
      }
      if (box && entryLinksDirty) {
        connectEntryLinks();
        entryLinksDirty = false;
      }
      const cartOpen = document.querySelector('#rebuy-cart.is-visible');
      const boxRect = box?.getBoundingClientRect();
      const heroSection = box && findHeroSection();
      const heroRect = heroSection?.getBoundingClientRect();
      const desktopTriggerOffset = window.matchMedia('(min-width: 769px)').matches ? window.innerHeight * 0.25 : 0;
      const reachedTrigger = heroRect ? heroRect.bottom <= desktopTriggerOffset : !!boxRect && boxRect.bottom <= 0;
      const show = !!box && reachedTrigger && !cartOpen;
      bar.hidden = !show;
      document.body.classList.toggle('kion-lp-buy-bar-visible', show);
      if (show) document.body.style.setProperty('--kion-lp-buy-bar-height', `${bar.offsetHeight}px`);
    }

    function schedule() {
      if (queued) return;
      queued = true;
      requestAnimationFrame(update);
    }

    button.addEventListener('click', scrollToBuyBox);
    window.addEventListener('scroll', schedule, { passive: true });
    window.addEventListener('resize', () => {
      contentDirty = true;
      entryLinksDirty = true;
      schedule();
    }, { passive: true });
    window.addEventListener('load', schedule);
    document.addEventListener('change', () => {
      contentDirty = true;
      schedule();
    });
    new MutationObserver((mutations) => {
      if (
        mutations.some((mutation) =>
          mutation.target !== bar &&
          !bar.contains(mutation.target) &&
          (mutation.type === 'childList' || mutation.target.id === 'rebuy-cart')
        )
      ) {
        entryLinksDirty = true;
        schedule();
      }
    }).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });
    schedule();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
